import { IS_TRACKING_ENABLED } from '@/common/constants';
import { posthogStandIn } from '@/lib/analytics/posthog-stand-in';

/** An error boundary's error, held with its time until analytics starts if it hasn't yet. */
export function captureExceptionToPostHog(error: Error) {
  if (!IS_TRACKING_ENABLED) return;
  if (window.__chatEarly) {
    posthogStandIn.captureException(error);
    return;
  }
  // `global-error.tsx` replaces the whole page, start-up script included, when the root layout
  // fails, so posthog never starts there. Loaded only then; the shared package never imports
  // posthog-js.
  void import('@/lib/analytics/capture-without-start-up')
    .then(({ captureWithoutStartUpScript }) => captureWithoutStartUpScript({ error }))
    .catch(() => {
      // Reporting an error must never become one.
    });
}
